import type { SelectDropdownItem } from '@/types/Base';

export function enumToMap<T extends { [key: string]: string | number }>(
  enumObj: T
): Record<number | string, string> {
  return Object.keys(enumObj)
    .filter((key) => isNaN(Number(key)))
    .reduce(
      (acc, key) => {
        acc[enumObj[key]] = key;
        return acc;
      },
      {} as Record<number | string, string>
    );
}

export function enumToDropdownItems<T extends { [key: string]: string | number }>(
  enumObj: T
): SelectDropdownItem[] {
  return Object.keys(enumObj)
    .filter((key) => isNaN(Number(key)))
    .map((key) => ({
      value: enumObj[key],
      name: key.replace('_', ' '),
    }));
}
